import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const classHourStatisticsAdultEducation = {
    classHourStatistics: {
        initCombo: config => createAPI('/classHourStatisticsAdultEducation/classHourStatistics/initCombo', 'post', config),
        queryList: config => createAPI('/classHourStatisticsAdultEducation/classHourStatistics/queryList', 'post', config),
        save: config => createAPI('/classHourStatisticsAdultEducation/classHourStatistics/save', 'post', config),
        exportFile: config => createAPI('/classHourStatisticsAdultEducation/classHourStatistics/exportFile', 'post', config),
    }
};

export default classHourStatisticsAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/classHourStatisticsAdultEducation.js